import { coerce, gt, valid } from "semver";
import { create } from "zustand";

function checkServerNewer(serverVersion: string): boolean {
  // semver.coerce を用いて "v1.2dd" や "1.2.3+meta" のような緩い表記も許容する
  const serverSemver = valid(serverVersion) ? serverVersion : coerce(serverVersion)?.version;
  const clientSemver = valid(__APP_VERSION__) ? __APP_VERSION__ : coerce(__APP_VERSION__)?.version;

  if (!serverSemver || !clientSemver) {
    // 解析できない場合は何もしない（フェイルセーフ）
    return false;
  }

  const isServerNewer = gt(serverSemver, clientSemver);

  if (isServerNewer) {
    console.log("Server version is newer than client version");
  }
  return isServerNewer;
}

function getAppVersion(serverVersion: string): string {
  return __APP_VERSION__ === serverVersion ? `v${__APP_VERSION__}` : `v${__APP_VERSION__} (v${serverVersion})`;
}

type VersionState = {
  appVersion: string;
  clientVersion: string;
  isServerNewer: boolean;
  serverVersion: string;
  setServerVersion: (serverVersion: string) => void;
};

export const useVersionStore = create<VersionState>()((set) => ({
  appVersion: getAppVersion(""),
  clientVersion: __APP_VERSION__,
  isServerNewer: false,
  serverVersion: "",
  setServerVersion: (serverVersion) =>
    set((state) => {
      return {
        ...state,
        appVersion: getAppVersion(serverVersion),
        isServerNewer: checkServerNewer(serverVersion),
        serverVersion,
      };
    }),
}));
